import React from 'react';
import { Location } from '../../types/models';

interface Filters {
  locationId: string;
  startDate: string;
  availableOnly: boolean;
}

interface Props {
  filters: Filters;
  locations: Location[];
  onChange: (filters: Filters) => void;
}

export const ClassFilter: React.FC<Props> = ({ filters, locations, onChange }) => {
  const set = (patch: Partial<Filters>) => onChange({ ...filters, ...patch });

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 flex flex-wrap gap-4 items-end">
      <div className="flex-1 min-w-40">
        <label className="block text-xs font-medium text-gray-600 mb-1">Location</label>
        <select
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
          value={filters.locationId}
          onChange={e => set({ locationId: e.target.value })}
        >
          <option value="">Select a location…</option>
          {locations.map(l => (
            <option key={l.locationId} value={l.locationId}>{l.displayName}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">From</label>
        <input
          type="date"
          className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
          value={filters.startDate}
          onChange={e => set({ startDate: e.target.value })}
        />
      </div>

      <div className="flex items-center gap-2 pb-2">
        <input
          id="availableOnly"
          type="checkbox"
          className="w-4 h-4 text-green-600 rounded"
          checked={filters.availableOnly}
          onChange={e => set({ availableOnly: e.target.checked })}
        />
        <label htmlFor="availableOnly" className="text-sm text-gray-700">Available spots only</label>
      </div>
    </div>
  );
};
